
import React, { useEffect, useRef, useState } from 'react';
import { FileUpload } from 'primereact/fileupload';
import { Button } from 'primereact/button';
import useApiPrivate from '../../utils/hooks/useApiPrivate';
import styles from './Upload.module.scss';
import { Toast } from 'primereact/toast';
import useWindowSize from '../../utils/hooks/useWindowSize';

const GALLERY_URL = 'api/v1/gallery';

export default function Upload({mode, productId, multiple, callProduct, name, accept, required, handleImages, outSideRequest, isUploadButton}) {
    const fileUploadRef = useRef(null);
    const apiPrivate = useApiPrivate();
    const toast = useRef(null);

    const [isLoading, setIsLoading] = useState(false);
    const [images, setImages] = useState('');
    const { width } = useWindowSize();

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const galleriesUploadHandler = async () => {
        if(outSideRequest){
            return
        }

        setIsLoading(true);

        const formData = new FormData();

        for (let i = 0; i < images.length; i++) {

            formData.append('product_id', productId);
            formData.append(`${name}`, images[i]);

            try {
                const response = await apiPrivate.post(GALLERY_URL,formData,{
                    headers: {
                        'content-type': 'multipart/form-data',  
                    }}
                )
                setIsLoading(false);
                showSuccess('Image uploaded successfully')
            }
            catch (error) {
                if(error?.response?.status === 422) {
                    showError('The image must be a file of type: jpg, png, jpe, jpeg')
                } else {
                    showError('Failed')
                }
            }
          }
          fileUploadRef.current.clear();
          setTimeout(() => {
              callProduct();
        }, 2000)

    }

    const onTemplateSelect = (e) => {
        let filesList = e.files;
        setImages(filesList);
    };

    const onTemplateRemove = (file, callback) => {
        const result = images.filter((item) => item !== file);
        setImages(result);
        callback();
    };

    useEffect(() => {
        handleImages(images);
    },[images])
    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;   

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {isUploadButton && uploadButton}
                {cancelButton}
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="d-flex align-items-center flex-wrap">
                <div className="d-flex align-items-center" style={{ width: `${width < 576 ? '80%' : '60%'}` }}>
                    <img alt={file.name} role="presentation" src={file.objectURL} width={`${width < 576 ? '50' : '100'}`} />
                    <span className={`d-flex flex-column text-left ms-3 ${styles.imageTitle}`}>
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Button type="button" icon="bi bi-x-lg" className={`btn p-button text-danger border-0 ms-auto`} onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="d-flex align-items-center flex-column">
                <i 
                    className={`${multiple ? 'bi-images' : 'bi-image'} bi mt-3 me-2`} 
                    style={{ fontSize: '2.5em', borderRadius: '50%', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: width < 768 ? '1em' : '1.2em', color: 'var(--text-color-secondary)' }} className="my-2">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };

    const chooseOptions = { 
        icon: `bi ${multiple ? 'bi-images' : 'bi-image'}`,
        iconOnly: false, 
        className: `p-button btn btn-secondary ${styles.uploadBtn}`, label:'Choose file' };
    const uploadOptions = { 
        icon: 'bi bi-upload', 
        iconOnly: false, 
        className: `p-button-success p-button btn-secondary btn ${styles.uploadBtn}`, label:'Upload' };
    const cancelOptions = { 
        icon: 'bi bi-x-lg', 
        iconOnly: false, 
        className: `p-button-danger  btn-secondary btn p-button ${styles.uploadBtn}`, label:'Cancel' };
    return (
        <div>
           <Toast ref={toast} position="top-center" />

            <FileUpload 
                name={`${name}`}
                accept={accept}
                customUpload={true}
                uploadHandler={galleriesUploadHandler}
                mode={mode ? 'basic' : 'advanced'}
                multiple={multiple}
                required={required}
                ref={fileUploadRef}  
                onSelect={onTemplateSelect} 
                headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
        </div>
    )
}
        